<template>
  <div class="serviceSupport">
    <pageHeader
      :actNum="3"
      :bannerImg="bannerImg"
      bannerText="- Uphold"
      bannerText2="Professionalism"
    />
    <div class="top">
      <div class="top-left">您的位置：<span class="homeSpan" @click="tarHome()">首页</span
      > > 服务支持</div>
    </div>
    <div class="content">
      <div class="content-left">
        <img :src="supportImg" />
      </div>
      <div class="content-right">
        <div class="content-right-box1">
          <div class="title">服务⽀持</div>
          <div class="text">普康产品服务⽀持</div>
          <div class="text">为客户提供全⾯且贴⼼的服务</div>
        </div>
        <div class="content-right-box2">
          <div class="title">服务理念</div>
          <div class="text">
            普康医疗始终坚持最初的产品理念和⽬标，始终保持着对品质的严格把控和服务不断优良，为客户提供更加优质的使⽤体验。坚持从客户⻆度出发，倾听客户的每⼀个声⾳，关注客户的每⼀个需求，做到服务带动品牌，服务造就⼝碑。确保客户在享受服务的过程中，能够感受到我们服务团队的专业和⾼效。
          </div>
          <div class="textLi">
            <div class="radio"></div>
            <span>快速响应，客户需求免等待</span>
          </div>
          <div class="textLi">
            <div class="radio"></div>
            <span>量身定制，打造专属管理⽅案</span>
          </div>
          <div class="textLi">
            <div class="radio"></div>
            <span>全程跟踪，服务进度实时把握</span>
          </div>
          <div class="textLi">
            <div class="radio"></div>
            <span>专业技术培训，客户上⼿快</span>
          </div>
        </div>
        <div class="content-right-box3">
          <div class="title">服务团队</div>
          <div class="textLi">
            <div class="radio"></div>
            <span>业务专业 经验丰富</span>
          </div>
          <div class="text">团队成员拥有丰富的⼯作经验和深厚的专业知识，深耕医疗领域多年，具备扎实的业务能⼒和专业技术，能够迅速应对各种复杂问题，为客户提供精准有效的解决⽅案。</div>
          <div class="textLi">
            <div class="radio"></div>
            <span>⾼效协作 迅速响应</span>
          </div>
          <div class="text">团队成员之间默契配合，形成⾼效的⼯作机制，确保服务流程的顺畅进⾏，能够迅速响应客户需求，⾼效解决问题。</div>
          <div class="textLi">
            <div class="radio"></div>
            <span>贴⼼服务，客户⾄上</span>
          </div>
          <div class="text">团队成员始终坚持保持热情周到的服务态度，全⼼全意为客户服务，满⾜客户的需求和期望。</div>
        </div>
      </div>
    </div>
    <footPage />
  </div>
</template>

<script>
import pageHeader from "@/components/pageHeader/index.vue";
import footPage from "@/components/foot/index.vue";
import bannerImg from "@/assets/img/banner_support.png";
import supportImg from "@/assets/img/img_support.png";
export default {
  name: "serviceSupport",
  components: {
    pageHeader,
    footPage,
  },
  data() {
    return {
      bannerImg,
      supportImg,
    };
  },
  methods:{
    tarHome(){
      this.$router.push('/')
    },
  }
};
</script>

<style lang="scss" scoped>
.serviceSupport {
  .top {
    padding: 52px 260px;
    &-left {
      font-size: 15px;
    }
  }
  .content {
    margin-top: 50px;
    margin-bottom: 175px;
    padding: 0 260px;
    display: flex;
    align-items: center;
    color: #333;
    &-left {
      // width: 588px;
      // height: 705px;
      img {
        // width: 100%;
        // height: 100%;
        width: 588px;
      }
    }
    &-right {
      margin-left: 80px;
      &-box1{
        .title{
          font-size: 22px;
        }
        .text{
          font-size: 15px;
          color: #666;
          line-height: 28px;
          margin-top: 10px;
        }
      }
      &-box2{
        margin-top: 30px;
        .title{
          font-size: 16px;
        }
        .text{
          margin-top: 10px;
          font-size: 15px;
          color: #666;
          line-height: 28px;
        }
        .textLi{
          margin-top: 10px;
          display: flex;
          align-items: center;
          .radio{
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #666;
          }
          span{
            margin-left: 5px;
            font-size: 15px;
            color: #666;
          }
        }
      }
      &-box3{
        margin-top: 30px;
        .title{
          font-size: 16px;
        }
        .text{
          margin-top: 10px;
          font-size: 15px;
          color: #666;
          line-height: 28px;
        }
        .textLi{
          margin-top: 10px;
          display: flex;
          align-items: center;
          .radio{
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #666;
          }
          span{
            margin-left: 5px;
            font-size: 15px;
            color: #666;
          }
        }
      }
    }
  }
}
</style>